import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const Error404 = () => {
const {t}= useTranslation();
  return (
    <Container
      style={{ marginTop: "200px", marginBottom: "131px", color: "#212529" }}
    >
      <h2 style={{ fontSize: "150px", fontWeight: "700" }}>404</h2>
      <p style={{ fontSize: "30px", fontWeight: "700" }}>
        {t("errorMessage.notPageFound")}
      </p>
    </Container>
  );
};

export default Error404;
